module.exports = __webpack_public_path__ + "static/wavinglife-ff419c37502c8707e2d7916bcec54bf8.jpg";